import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import { format } from "date-fns";
import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { ISubvendorInvoice } from "./Form";
import { ILogin } from "../../models/Login";
import { useNavigate } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { AutoComplete } from "primereact/autocomplete";
import { Tooltip } from "primereact/tooltip";

interface IProps {
    open: boolean,
    openForm: (data: any) => void,
    setModal: (data: any) => void,
    reload: boolean,
    toast: any,
    byPrimeInvoice?: { singleData: any, open: boolean },
    po?: any,
}

export interface ISubvendorInvoiceList {
    id?: number,
    consultant_ID?: number,
    consultant_Name?: string,
    vendor_Company_ID?: number,
    vendor_Company_Name?: string,
    invoiceNO?: string,
    invoiceDate?: Date,
    fromDate?: Date,
    toDate?: Date,
    workingHours?: number,
    bRate?: number,
    invoiceAmount?: number,
    dueDate?: Date,
    payment_Mode?: string,
    payment_Date?: Date,
    paymentStatus?: string,
    transaction_ID?: string,
    pO_ID?: number,
    requestedAmount?: number,
    invoicePath?: string,
    paidAmount?: number,
    primeVendor_Company_Name?: string,
    verfiedBy?: boolean,
    isVerfied?: boolean,
    verifyComment?: string,
    additional_Expenses_Amount?: number
}

export const Table = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: ISubvendorInvoiceList[], loading: boolean });
    const [subvendorCompData, setSubvendorCompData] = useState<any>();
    const [rejectionReasonModal, setRejectionReasonModal] = useState({ reason: "", open: false } as { reason: string, open: boolean });
    const [consultant, setConsultant] = useState<Array<any>>();
    const [value2, setValue2] = useState({ consultant_ID: 0, consultant_Name: "" } as { consultant_ID: number | null, consultant_Name: string | null });
    const [showAdditionalExpensesModel, setShowAdditionalExpensesModel] = useState({ open: false, singleData: {} } as { open: boolean, singleData: ISubvendorInvoiceList });
    const [additionalExpensesList, setAdditionalExpensesList] = useState<Array<{ id: any, description: string, hours: number, rate: number, amount: number }>>([]);

    const navigate = useNavigate();
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem("auth") + "");

    const loadConsultant = async (filter: string | null) => {
        const response = await Fetch(`Dropdown/consultantBySeacrhQuery`, "GET", null, `searchQuery=${filter}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            const emptyData = {
                consultant_ID: 0,
                consultant_Name: "-- SELECT --",
            };
            data.unshift(emptyData);
            setConsultant(data);
        }
    };

    const completeMethodConsultant = (event: { query: string }) => {
        //setValue2(prev => prev = { consultant_ID: 0, consultant_Name: "" });
        loadConsultant(event.query);
    }

    const rightToolbarTemplate = () => {
        return (
            <>
                <AutoComplete suggestions={consultant} completeMethod={completeMethodConsultant} field={"consultant_Name"} forceSelection value={value2} placeholder={"Search Consultant"} onChange={(e) => setValue2(e.value)} />
                <Button icon="pi pi-search" className="p-button p-button-info mr-2" onClick={() => {
                    if (value2.consultant_ID !== undefined && value2.consultant_ID !== 0 && value2.consultant_Name !== null && value2.consultant_Name?.trim() !== "") {
                        loadTableData();
                    }
                }} />
            </>
            // <Button
            //     label="Bulk Update Payment Status"
            //     onClick={() => {
            //         // if (selectedBenchs && selectedBenchs.length > 0) {
            //         //     setOpenHotList(true); // Open bulk update modal
            //         // } else {
            //         //     props.toast.current.show({
            //         //         severity: 'warn',
            //         //         detail: 'Please select at least one invoice.',
            //         //         life: 3000,
            //         //     });
            //         // }
            //     }}
            // />
            //<></>
        );
    };

    const leftToolbarTemplate = () => {
        if (props?.byPrimeInvoice?.singleData?.pO_ID) {
            return <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => {
                // props.setModal({ singleData: props?.byPrimeInvoice?.singleData, recent: tableData.tableData[0] || { pO_ID: props?.byPrimeInvoice?.singleData?.pO_ID }, open: true });
                props.setModal({
                    singleData: {
                        subvendorCompany_ID: {
                            vendor_Company_ID: subvendorCompData.vendor_Company_ID,
                            vendor_Company_Name: subvendorCompData.vendor_Company_Name,
                        }
                    }, recent: {}, open: true
                });
            }} />
        }
        return (
            // props.permissions.is_Create ?
            //             <React.Fragment>
            //                 <div className="my-2">
            //                     <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
            //                 </div>
            //             </React.Fragment>: '';
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const openNew = () => {
        props.openForm({
            vendor_Company_ID: subvendorCompData.vendor_Company_ID,
            vendor_Company_Name: subvendorCompData.vendor_Company_Name,
        });

    }

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const generated_Date = (rowData: any) => {
        let date;
        if (rowData.generated_Date) date = format(new Date(rowData.generated_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };


    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const dueDate = (rowData: any) => {
        let date;
        if (rowData.dueDate) date = format(new Date(rowData.dueDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const paymentDate = (rowData: any) => {
        let date;
        if (rowData.payment_Date) date = format(new Date(rowData.payment_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const action = (rowData: ISubvendorInvoiceList) => {
        return rowData.id && (rowData.isVerfied === null) ? <React.Fragment>
            <Button icon="pi pi-pencil" className="text-primary bg-white border-none" label="Edit" onClick={() => {
                //setGenerateInvoices({ singleData: rowData, open: true, action: false });
                props.setModal({ singleData: rowData, open: true });
            }
            }></Button>
        </React.Fragment> : (rowData.isVerfied === false ? <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
            <span style={{ color: "red", textDecoration: "underline", cursor: "pointer" }} onClick={() => setRejectionReasonModal(prev => prev = { reason: rowData.verifyComment || "", open: true })}>Rejected</span>
            <Button icon="pi pi-pencil" className="text-primary bg-white border-none" label="Edit" onClick={() => props.setModal({ singleData: rowData, open: true })}></Button>
        </div> : <React.Fragment><span style={{ color: "green" }}>Verfied</span></React.Fragment>);
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        let query = "";
        if (loginObj.user_Type === 2) {
            if (value2.consultant_Name !== undefined && value2.consultant_Name !== null && value2.consultant_Name.trim() !== "") {
                query = `consultantUser=${loginObj.consultant_ID}&consultantName=${value2.consultant_Name}&userType=${loginObj.user_Type}`;
            } else query = `consultantUser=${loginObj.consultant_ID}&userType=${loginObj.user_Type}&consultantName=${""}`;
        }

        if (loginObj.user_Type === 3) {
            if (value2.consultant_Name !== undefined && value2.consultant_Name !== null && value2.consultant_Name.trim() !== "") {
                query = `subvendorUser=${loginObj.sub_Vendor_ID}&consultantName=${value2.consultant_Name}&userType=${loginObj.user_Type}`;
            } else query = `subvendorUser=${loginObj.sub_Vendor_ID}&userType=${loginObj.user_Type}&consultantName=${""}`;
        }

        if (loginObj.user_Type === 4) {
            if (value2.consultant_Name !== undefined && value2.consultant_Name !== null && value2.consultant_Name.trim() !== "") {
                query = `consultantName=${value2.consultant_Name}&userType=${loginObj.user_Type}`;
            } else query = `userType=${loginObj.user_Type}&consultantName=${""}`;
        }

        const response = await Fetch("ResourceInvoices/subvendorInvoice", "GET", null, query, props.toast);

        if (response) {
            const data: ISubvendorInvoiceList[] = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: tableData.tableData, loading: false });
    };

    const downLoadInvoice = async (rowData: ISubvendorInvoiceList) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'application/pdf',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"InvoiceTracking/downloadSubvendor"}?path=${rowData.invoicePath}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${rowData?.invoiceNO}.pdf`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    };

    const svInvoice = (rowData: ISubvendorInvoiceList) => {
        return <p className="cursor-pointer text-cyan-700 underline" style={{ cursor: "pointer" }} onClick={() => downLoadInvoice(rowData)}>{rowData.invoiceNO}</p>
    };

    const getSubvendorDetails = async () => {
        const response = await Fetch("ResourceVendor_Company_Mast", "GET", null, null, null);
        if (response) {
            const data = await response.json();
            setSubvendorCompData(data);
        }
    };

    const goToDashboard = () => {
        navigate("/dashboard");
    };

    useEffect(() => {
        getSubvendorDetails();
        loadTableData();
    }, [props.reload]);

    const rowClass = (data: any) => {
        return {
            'bg-green-300 text-black': data.paymentStatus === "Paid",
            'bg-blue-200 text-black': data.paymentStatus === "Balance",
            'bg-pink-300 text-black': data.paymentStatus === "Pending",
            'bg-orange-300 text-black': data.paymentStatus === "Over Payment",

        };
    }

    const loadAdditionalExpenses = async (id: number) => {
        const response = await Fetch("InvoiceTracking/getAdditionalExpenses", "GET", null, `invoiceID=${id}`, null);
        if (response) {
            const data: { id: any, description: string, hours: number, rate: number, amount: number }[] = await response.json();
            setAdditionalExpensesList(data);
        }
    }

    return (
        <>
            {!props?.po?.pO_ID && <p className="w-full flex justify-content-between pr-2"><span style={{ fontWeight: "bold" }}>My Invoices</span><span></span><Button className="w-12rem" label="Go to Dashboard" onClick={goToDashboard} icon="pi pi-arrow-left" /></p>}
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            {/* <Accordion> */}
            {/* <AccordionTab header="Filter"> */}
            {/* <Filter invoiceFilter={invoiceFilter} setReqFilter={(invoiceFilter: InvoiceTrackingFilter) => setInvoiceFilter(invoiceFilter)} toast={props.toast} byPO_ID={props.po.pO_ID ? true : false} /> */}
            {/* </AccordionTab> */}
            {/* </Accordion> */}
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                value={tableData.tableData}
                loading={tableData.loading}
                // selection={selectedBenchs}
                stripedRows resizableColumns showGridlines columnResizeMode="expand"
                // onSelectionChange={(e) => setSelectedBenchs(e.value)}
                // selectionMode="multiple"
                dataKey="invoice_ID"
                paginator
                rows={10}
                rowsPerPageOptions={[5, 10, 20]}
                rowClassName={rowClass}
            >
                {/* <Column selectionMode="multiple" /> */}
                <Column header="SN." body={(rowData, options) => options.rowIndex + 1} footer={"Total Amount"} />
                <Column field="consultant_Name" header="Name" />
                <Column field="vendor_Company_Name" header="Sub Vendor" />
                <Column field="invoiceNO" header="Invoice#" body={(rowData: ISubvendorInvoiceList) => svInvoice(rowData)} />
                <Column field="generated_Date" header="Generated Date" body={generated_Date} />
                <Column field="fromDate" header="From Date" body={fromDate} />
                <Column field="toDate" header="To Date" body={toDate} />
                <Column field="dueDate" header="Due Date" body={dueDate} />
                <Column field="workingHours" header="Hours" />
                <Column field="bRate" header="B.Rate" />
                <Column field="invoiceAmount" header="Inv.Amount" footer={() => {
                    const invAmnt = tableData.tableData.reduce((sum, item) => sum + (item.invoiceAmount || 0), 0);
                    return <span className="">{invAmnt}</span>;
                }} />
                <Column field="additional_Expenses_Amount" header="Additional Expenses" body={(rowData: ISubvendorInvoiceList) => <p className="cursor-pointer text-cyan-700 underline" onClick={() => {
                        if (rowData?.id !== undefined && rowData?.id !== null && rowData?.id > 0) loadAdditionalExpenses(rowData?.id || 0);
                        setShowAdditionalExpensesModel({ open: true, singleData: rowData });
                    }}>{rowData.additional_Expenses_Amount}</p>} footer={() => {
                    const invAmnt = tableData.tableData.reduce((sum, item) => sum + (item.additional_Expenses_Amount || 0), 0);
                    return <span className="">{invAmnt}</span>;
                }} />
                <Column field="" header="Total Inv Amount" body={(rowData: ISubvendorInvoiceList) => <p>{(rowData.invoiceAmount || 0) + (rowData.additional_Expenses_Amount || 0)}</p>} footer={() => {
                    const reqAmnt = tableData.tableData.reduce((sum, item) => sum + ((item.requestedAmount || 0) + (item.additional_Expenses_Amount || 0)), 0);
                    return <span className="">{reqAmnt}</span>;
                }} />
                <Column field="requestedAmount" header="Requested Amount" footer={() => {
                    const reqAmnt = tableData.tableData.reduce((sum, item) => sum + (item.requestedAmount || 0), 0);
                    return <span className="">{reqAmnt}</span>;
                }} />
                <Column field="paidAmount" header="Paid Amount" footer={() => {
                    const paidAmnt = tableData.tableData.reduce((sum, item) => sum + (item.paidAmount || 0), 0);
                    return <span className="">{paidAmnt}</span>;
                }} />
                <Column field="payment_Mode" header="Payment Mode" />
                <Column field="transaction_ID" header="Transaction" />
                <Column field="payment_Date" header="Payment Date" body={paymentDate} />
                <Column field="paymentStatus" header="Payment Status" />
                {/* <Column field="aging" header="Aging" /> */}
                {/* <Column field="" header="Send Email" /> */}
                {!props.byPrimeInvoice?.open && <Column header="Action" body={action} />}
            </DataTable>
            <Dialog visible={rejectionReasonModal.open} style={{ width: '50vw' }} header="Invoice Rejection Reason" modal className="p-fluid" onHide={() => setRejectionReasonModal(prev => prev = { reason: "", open: false })}>
                <h5>{rejectionReasonModal.reason.trim() === "" ? "No Reason Mentioned" : rejectionReasonModal.reason}</h5>
            </Dialog>

            <Dialog visible={showAdditionalExpensesModel.open} style={{ width: '50vw' }} header="Additional Expenses List" modal className="p-fluid" onHide={() => setShowAdditionalExpensesModel({ open: false, singleData: {} })}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    value={additionalExpensesList}
                    stripedRows resizableColumns showGridlines columnResizeMode="expand"
                    dataKey="id"
                >
                    <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="description" header="Description" />
                    <Column field="hours" header="Hours" />
                    <Column field="rate" header="Rate" />
                    <Column field="amount" header="Amount" />
                </DataTable>
            </Dialog>
        </>
    );
}